import styled from "styled-components";
import { colors } from "assets";

export default c => styled(c)`
  width: 100%;
  overflow-y: auto;
  background: radial-gradient(
    at 50% 100%,
    ${colors.primary.normal} 20%,
    ${colors.primary.dark} 90%
  );
`;



// WEBPACK FOOTER //
// ./src/components/app/password-recovery/style.js